export default __webpack_public_path__ + "static/media/undraw_confirmed_c5lo.7b4b2266.svg";